module.exports = __webpack_public_path__ + "static/media/Dr. Mohammed AlKolaidi.1b990699.jpg";